import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';
import styled, { inputImages, inputNumbers, inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../../Components/Titlebar';
import { Items } from '../TitleList';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { createItemEntry, fetchItemCode } from '../../Store/PHPSlice/Item';
import { selectFirm, selecticode, selectlocationdata } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';


const ItemMaster = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        locId: '',
        firmId: '',
        itemNm: '',
        hsn: '',
        itemImg: '',
        size: '',
        icode: '',
        userId: userdata?.ID
    });
    const [number, setNumber] = useState('');
    const [numbers, setNumbers] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();

    const icode = useSelector(selecticode);
    const firmlist = useSelector(selectFirm);
    const loclist = useSelector(selectlocationdata);

    useEffect(() => {
        dispatch(fetchItemCode());
        dispatch(fetchCompanyData());
        dispatch(fetchLocationData());
    }, [dispatch]);

    useEffect(() => {
        if (icode?.data) {
            const val = icode.data;
            setFormData(prev => ({
                ...prev,
                icode: val
            }));
        }
    }, [icode]);

    const handleAddNumber = () => {
        if (number !== '') {
            const rangePattern = /^(\d+)-(\d+)$/;
            const match = number.match(rangePattern);

            const rangePattern2 = /^(\d+)-/;
            const match2 = number.match(rangePattern2);
            if (match) {
                const start = parseInt(match[1], 10);
                const end = parseInt(match[2], 10);

                if (start <= end) {
                    // Create an array of numbers from start to end with a difference of 2
                    const rangeArray = [];
                    // // If the start is between 1 and 19, generate numbers with a step of 1
                    // if (start >= 1 && start <= 19) {
                    //     for (let i = start; i <= end; i += 1) {
                    //         rangeArray.push(i);
                    //     }
                    //     if (end % 2 === 0 && !rangeArray.includes(end)) {
                    //         rangeArray.push(end);
                    //     }
                    // } else {
                    //     // Else generate numbers with a difference of 2
                    //     for (let i = start; i <= end; i += 2) {
                    //         rangeArray.push(i);
                    //     }
                    // }

                    // Generate numbers from start to end
                    for (let i = start; i <= end; i++) {
                        if (i <= 20 || i % 2 === 0) {
                            rangeArray.push(i);
                        }
                    }

                    // Ensure the end number is included if odd
                    if (end > 20 && end % 2 !== 0 && !rangeArray.includes(end)) {
                        rangeArray.push(end);
                    }

                    // Add the generated range to the numbers list
                    setNumbers([...numbers, ...rangeArray]);
                }
            }
            else if (match2) {
                alert(`Complete the Sizes Value ${number}`);
            } else {
                // If the input doesn't match the range format, add the string directly to the numbers list
                setNumbers([...numbers, number]);
            }
            setNumber('');  // Clear the input field after processing
        }
    };


    const handleSelectRow = (index) => {
        setSelectedRows(prevSelectedRows => {
            if (prevSelectedRows.includes(index)) {
                return prevSelectedRows.filter(rowIndex => rowIndex !== index);
            } else {
                return [...prevSelectedRows, index];
            }
        });
    };

    const handleDeleteSelected = () => {
        const filteredNumbers = numbers.filter((_, index) => !selectedRows.includes(index));
        setNumbers(filteredNumbers);
        setSelectedRows([]); // Clear selection after delete
    };

    const validateInput = (value) => {
        // Regular expression for validating simple numbers (e.g., 22, 45)
        const validNumberPattern = /^\d+$/;

        // Regular expression for validating the allowed range formats (e.g., 20-30, 20/30, 20X30, or 20x30)
        const validRangePattern = /^\d+[-/Xx]\d+$/;

        // Check if the input is a valid number or a valid range format
        if (!validNumberPattern.test(value) && !validRangePattern.test(value)) {
            setErrors({ sizes: 'Invalid input format. Please use the format like 20-30, 20/30, 20X30, or just a number like 22.' });
            return false;
        }

        setErrors({ sizes: '' });  // Clear any errors if input is valid
        return true;
    };

    const handleChange = (e) => {
        const value = e.target.value;

        // Allow only numbers and valid characters (hyphen, slash, X, x)
        const restrictedPattern = /^[0-9]+[-/Xx]?[0-9]*$/;  // This pattern allows numbers with optional valid separator

        // Check if the value matches the allowed restricted pattern or is an empty string
        if (restrictedPattern.test(value) || value === '') {
            setNumber(value);
            // Validate input on each change
            validateInput(value);
        }
    };



    const handleNumberChange = (index, value) => {
        const updatedNumbers = numbers.map((num, i) => (i === index ? value : num));
        setNumbers(updatedNumbers);
    };

    const handleImageChange = (e) => {
        setFormData({
            ...formData,
            itemImg: e.target.files[0]
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.itemNm) newErrors.itemNm = 'Item Name is required';
        if (!formData.hsn) newErrors.hsn = 'HSN Code is required';
        if (numbers.length === 0) newErrors.sizes = 'At least one size is required';
        // if (!formData.firmId) newErrors.firmId = 'HSN Code is required';
        if (!formData.locId) newErrors.locId = 'Location is required';
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const updatedFormData = {
            ...formData,
            size: numbers.join(',')
        };
        const sizeArr = numbers.join(',')
        const formDataToSend = new FormData();
        // formDataToSend.append('firmId', formData.firmId);
        formDataToSend.append('locId', formData.locId);
        formDataToSend.append('itemNm', formData.itemNm);
        formDataToSend.append('hsn', formData.hsn);
        formDataToSend.append('icode', formData.icode);
        formDataToSend.append('userId', formData.userId);
        formDataToSend.append('size', sizeArr);

        if (formData.itemImg instanceof File) {
            formDataToSend.append('itemImg', formData.itemImg);
        }

        dispatch(createItemEntry(formDataToSend))
            .unwrap()
            .then((result) => {
                console.log('POST request successful!', result);
                // toast.success("Item Added");
                alert("Item Added");
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error while making POST request:', error);
            });
    };

    const isDesktop = useMediaQuery('(min-width:768px)');

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };
    const dropdownFirm = [
        // {
        //     label: 'Firm',
        //     id: 'firmId',
        //     options: firmlist?.data || [],
        //     value: formData.firmId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
        //     getOptionLabel: (option) => option.firmNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.firmId
        // },
         {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.locId
        }
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };
    return (
        <>
            <Titlebar data={Items} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Item Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1.2}>

                                {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                }


                                {[
                                    { label: 'Item Name', name: 'itemNm' },
                                    { label: 'HSN Code', name: 'hsn' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='itemImg'>Image:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='itemImg'
                                                    name='itemImg'
                                                    type="file"
                                                    onChange={handleImageChange}
                                                    inputProps={{ style: styled.inputImg }}
                                                    sx={inputImages}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6}>

                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='number'>Sizes:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.sizes}>
                                                <TextField
                                                    type='text'
                                                    id='number'
                                                    name='number'
                                                    value={number}
                                                    onChange={handleChange}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}
                                                />
                                                {errors.sizes && <FormHelperText style={errorStyles}>{errors.sizes}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Button variant="contained" color="primary" onClick={handleAddNumber} disabled={number == ""}>Add</Button>
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <Typography
                                        variant="body1" // or any other variant you prefer
                                        color="error" // This uses the default error color which is red in MUI
                                        sx={{
                                            color: 'red', // Directly set the color if you want a specific shade
                                            fontWeight: 'bold', // Optional: Make the text bold
                                        }}
                                    >
                                        If Range for Example: 20-30 <br />
                                        If Enter Size with Width then use ' / ' or ' X | x '
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <Button
                                        onClick={handleDeleteSelected}
                                        disabled={selectedRows.length === 0}
                                        variant="contained"
                                        color="error"
                                    >
                                        Delete
                                    </Button>
                                </Grid>

                                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                    <Table style={isDesktop ? { width: '40%' } : { width: '100%' }}>
                                        <TableHead>
                                            <TableRow className='tbl-row'>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>SrNo</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {numbers.map((num, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                        <Checkbox
                                                            checked={selectedRows.includes(index)}
                                                            onChange={() => handleSelectRow(index)}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                        <TextField
                                                            type="text"
                                                            value={num}
                                                            onChange={(e) => handleNumberChange(index, e.target.value)}
                                                            inputProps={{ style: styled.inputs }}
                                                            sx={inputNumbers}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={numbers.length == 0}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ItemMaster;
